import { config } from '@/config';
import { server, url } from '@/helpers';
import { CreatePaymentRequest, CreatePaymentResponse } from '@/types/api/services/qliro';

export const qliroServices = {
  createPayment,
  completePayment,
};

function createPayment(params: CreatePaymentRequest): Promise<CreatePaymentResponse> {
  return server.request.post('/qliro/payments', params).then(server.handleSuccess).catch(server.handleErrorObject);
}

function completePayment(reference: string, customerId: string): EventSource {
  const eventSource = new EventSource(
    `${url.getServerUrl()}qliro/payments/complete?merchantReference=${reference}&customerId=${customerId}`,
  );
  return eventSource;
}
